import * as React from 'react'
import * as classNames from 'classnames'
import { motion, AnimatePresence, Variants } from 'framer-motion'

import * as Style from './style.css'

import {
  ColorButton,
  BUTTON_TYPE_PINK,
  BUTTON_TYPE_BLUE,
} from '~/atoms/button/ColorButton'
import {
  LinkButton,
  BUTTON_TYPE_PINK as LINK_BUTTON_TYPE_PINK,
  BUTTON_TYPE_BLUE as LINK_BUTTON_TYPE_BLUE,
} from '~/atoms/button/LinkButton'

import PcEpisodeArrorDonw from './pc_episode_arrow_down.svg?reactCompornt'
import SpEpisodeArrorDonw from './sp_episode_arrow_down.svg?reactCompornt'

import PcSeparatorLinePink from './separator_line/pc_separator_line_pink.png'
import SpSeparatorLinePink from './separator_line/sp_separator_line_pink.png'
import PcSeparatorLineBlue from './separator_line/pc_separator_line_blue.png'
import SpSeparatorLineBlue from './separator_line/sp_separator_line_blue.png'

type ISupportType = typeof SUPPORT_TYPE_PINK | typeof SUPPORT_TYPE_BLUE

export interface IProps {
  lastEpisode: boolean
  supportType: ISupportType
  supporterName: string
  pcEpisode: string
  pcDevelopmentBefore: string
  pcDevelopmentAfterTop: string
  pcDevelopmentAfterBottom: string
  spEpisode: string
  spDevelopmentBefore: string
  spDevelopmentAfterTop: string
  spDevelopmentAfterBottom: string
  accordionOpen: boolean
  colorButtonAccordionTitle1: string
  colorButtonAccordionTitle2: string
  colorButtonHref: string
  linkButtonAccordionTitle1: string
  linkButtonAccordionTitle2: string
  linkButtonHref: string
  episodeClickHandler: () => void
}

export const SUPPORT_TYPE_PINK = 'PINK'
export const SUPPORT_TYPE_BLUE = 'BLUE'

export const ContentEpisodeRow = ({
  lastEpisode,
  supportType,
  supporterName,
  pcEpisode,
  pcDevelopmentBefore,
  pcDevelopmentAfterTop,
  pcDevelopmentAfterBottom,
  spEpisode,
  spDevelopmentBefore,
  spDevelopmentAfterTop,
  spDevelopmentAfterBottom,
  accordionOpen,
  colorButtonAccordionTitle1,
  colorButtonAccordionTitle2,
  colorButtonHref,
  linkButtonAccordionTitle1,
  linkButtonAccordionTitle2,
  linkButtonHref,
  episodeClickHandler,
  ...props
}: IProps): JSX.Element => {
  const episodeOpenStyle =
    supportType == SUPPORT_TYPE_PINK
      ? Style.ContentEpisodeRowEpisodeOpenButtonSitter
      : Style.ContentEpisodeRowEpisodeOpenButtonHousekeeping

  const accordionOpenVariants: Variants = {
    open: { height: 'auto', display: 'block' },
    closed: { height: 0, display: 'none' },
  }

  const colorButtonType =
    supportType === SUPPORT_TYPE_PINK ? BUTTON_TYPE_PINK : BUTTON_TYPE_BLUE
  const linkButtonType =
    supportType === SUPPORT_TYPE_PINK
      ? LINK_BUTTON_TYPE_PINK
      : LINK_BUTTON_TYPE_BLUE

  return (
    <div className={Style.ContentEpisodeRow}>
      <div className={Style.ContentEpisodeRowEpisode}>
        <img
          src={pcEpisode}
          className={classNames(
            Style.ContentEpisodeRowEpisodeImage,
            Style.TabletPcOnly,
          )}
        />
        <img
          src={spEpisode}
          className={classNames(
            Style.ContentEpisodeRowEpisodeImage,
            Style.SpOnly,
          )}
        />
      </div>
      {!accordionOpen && (
        <div className={Style.ContentEpisodeRowEpisodeOpen}>
          <button className={episodeOpenStyle} onClick={episodeClickHandler}>
            {supporterName}さんのストーリーを読む
            <PcEpisodeArrorDonw
              className={classNames(
                Style.ContentEpisodeRowEpisodeOpenArrow,
                Style.TabletPcOnly,
              )}
            />
            <SpEpisodeArrorDonw
              className={classNames(
                Style.ContentEpisodeRowEpisodeOpenArrow,
                Style.SpOnly,
              )}
            />
          </button>
        </div>
      )}
      <AnimatePresence>
        <motion.div
          initial={{ height: 0, display: 'none' }}
          animate={accordionOpen ? 'open' : 'closed'}
          variants={accordionOpenVariants}
          transition={{ duration: 0.3 }}
          style={{ overflow: 'hidden' }}
        >
          <div className={Style.ContentEpisodeRowEpisodeBefore}>
            <img
              src={pcDevelopmentBefore}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={spDevelopmentBefore}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentEpisodeRowAftreTop}>
            <img
              src={pcDevelopmentAfterTop}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={spDevelopmentAfterTop}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentEpisodeRowAftreBottom}>
            <img
              src={pcDevelopmentAfterBottom}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={spDevelopmentAfterBottom}
              className={classNames(
                Style.ContentEpisodeRowEpisodeImage,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentEpisodeRowEntry}>
            <ColorButton
              buttonType={colorButtonType}
              accordionTitle1={colorButtonAccordionTitle1}
              accordionTitle2={colorButtonAccordionTitle2}
              href={colorButtonHref}
            />
          </div>
          <div
            className={classNames({
              [Style.ContentEpisodeRowMagazine]: true,
              [Style.ContentEpisodeRowMagazineLast]: lastEpisode,
            })}
          >
            <LinkButton
              buttonType={linkButtonType}
              accordionTitle1={linkButtonAccordionTitle1}
              accordionTitle2={linkButtonAccordionTitle2}
              href={linkButtonHref}
            />
          </div>
          {!lastEpisode && (
            <div className={Style.ContentEpisodeRowBorder}>
              {supportType === SUPPORT_TYPE_PINK && (
                <>
                  <img
                    src={PcSeparatorLinePink}
                    className={classNames(
                      Style.ContentEpisodeRowEpisodeBorderImage,
                      Style.TabletPcOnly,
                    )}
                  />
                  <img
                    src={SpSeparatorLinePink}
                    className={classNames(
                      Style.ContentEpisodeRowEpisodeBorderImage,
                      Style.SpOnly,
                    )}
                  />
                </>
              )}
              {supportType === SUPPORT_TYPE_BLUE && (
                <>
                  <img
                    src={PcSeparatorLineBlue}
                    className={classNames(
                      Style.ContentEpisodeRowEpisodeBorderImage,
                      Style.TabletPcOnly,
                    )}
                  />
                  <img
                    src={SpSeparatorLineBlue}
                    className={classNames(
                      Style.ContentEpisodeRowEpisodeBorderImage,
                      Style.SpOnly,
                    )}
                  />
                </>
              )}
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
